export default __webpack_public_path__ + "static/media/members_icon_white.d6de7b58.svg";